import React from 'react';
import $ from 'jquery';
import BaseClass from '@/pages/BaseClass';

import Home from '@/pages/index';

import {
	HashRouter,
	BrowserRouter as Router,
	Route,
	IndexRoute,
	Switch,
	withRouter,
} from 'react-router-dom';

import {
	CommonValue,
	ngUrl,
	message,
	scrollTop,
} from '@/utils/tools';

export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
		};
	}
	
	componentDidMount()
	{
	}
	
	render()
	{
		return (
			<Router>
				<Route component={Home} />
			</Router>
		);
	}
};

